define((require) => {
    "use strict";

    const Class = require("shared/util/Class");

    /**
     * Regex to validate GUID.
     *
     * {@link http://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid}
     * @type {RegExp}
     */
    const REGEX_GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    /**
     * Generate a GUID/UUID String.
     *
     * @class GUID
     * @author avi
     */
    return Class.extend({}, {

        /**
         * Generates a GUID/UUID string.
         *
         * @returns {String} The generated GUID.
         * @example af8a8416-6e18-a307-bd9c-f2c947bbb3aa
         * @link http://slavik.meltser.info/?p=142
         */
        random() {
            return this._p8() + this._p8(true) + this._p8(true) + this._p8();
        },

        _p8(s) {
            const p = (`${Math.random().toString(16)}000000000`).substr(2, 8);
            return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
        },

        /**
         * Validates the supplied GUID/UUID, returning true if valid, false otherwise.
         *
         * {@link https://www.ietf.org/rfc/rfc4122.txt}.

         * @example af8a8416-6e18-a307-bd9c-f2c947bbb3aa
         *
         * @param   {String} guid The uuid as a string to validate; ignores casing. A falsey value will return
         *                        false.
         * @returns {Boolean} True if valid, false otherwise.
         */
        validate(guid) {
            return REGEX_GUID.test(guid || "");
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/util/GUID.js